<template>
    <div>
        <candidate-banner></candidate-banner>
        <div class="container">
            <div class="row">
                <div class="col-md-3">
                    <candidate-side-nav-layout></candidate-side-nav-layout>
                </div>
                <div class="col-md-9">
                    <form action="" @submit.prevent="update">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="dashboard-heading">
                                    <h1>Personal Information</h1>
                                </div>
                            </div>
                        </div>
<!--                        <div class="row">-->
<!--                            <div class="col-md-12">-->
<!--                                <div class="epp">-->
<!--                                    <div class="edit-profile-pic">-->
<!--                                        <img v-bind:src="image" v-if="image">-->
<!--                                        <img v-else src="/images/user_avatar.png" alt="">-->
<!--                                        <label for="cp-edit"><i class="fas fa-pencil-alt"></i></label>-->
<!--                                    </div>-->
<!--                                    <div class="pic-details">-->
<!--                                        <input type="file" id="cp-edit" class="file" @change="onPhotoUploaded">-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
                        <div class="row">
                            <div class="change-form-data">
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label class="ep-input-label" for="first_name">First Name</label>
                                        <input type="text" class="form-control dash-input" id="first_name"
                                               placeholder="First Name"
                                               name="first_name" v-model="first_name" disabled>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label class="ep-input-label" for="last_name">Last Name</label>
                                        <input type="text" class="form-control dash-input" id="last_name"
                                               placeholder="Last Name"
                                               name="first_name" v-model="last_name" disabled>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label class="ep-input-label" for="college" v-if="this.$store.getters.getUser['business_activity']" v-html="this.$store.getters.getUser['business_activity']"></label>
                                        <label class="ep-input-label" for="college" v-else>College</label>
                                        <input type="text" class="form-control dash-input" id="college"
                                               :placeholder="this.$store.getters.getUser['business_activity']"
                                               name="first_name" v-model="college" disabled>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label class="ep-input-label" for="location">Location</label>
                                        <input type="text" class="form-control dash-input" id="location"
                                               placeholder="Location"
                                               name="first_name" v-model="location">
                                        <div id="location-er" v-html="location_error"
                                             class="form-text text-muted"></div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label class="ep-input-label" for="phone">Phone</label>
                                        <input type="text" class="form-control dash-input" id="phone"
                                               placeholder="Phone Number"
                                               name="first_name" v-model="phone" disabled>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label class="ep-input-label" for="email">Email</label>
                                        <input type="text" class="form-control dash-input" id="email"
                                               placeholder="Email"
                                               name="first_name" v-model="email" disabled>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label class="ep-input-label" for="marks">CGPA or Marks</label>
                                        <input type="text" class="form-control dash-input" id="marks"
                                               placeholder="Enter CGPA or Marks" name="marks" v-model="marks">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <label class="ep-input-label" for="resume_upload">Upload Resume</label>
                                    <div class="field-resume_upload">
                                        <div class="file-upload-wrapper">
                                            <input type="file" id="resume_upload" class="resume_upload" name="resume" @change="uploadResume">
                                        </div>
                                    </div>
                                    <p class="error-msg" v-html="resumeError"></p>
                                </div>
                            </div>
                        </div>
                        <div class="row padd-top-20">
                            <div class="col-md-12">
                                <div class="dashboard-heading">
                                    <h1>Job Preferences</h1>
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-6">
                                <div class="form-group">
                                    <label class="ep-input-label" for="jobProfile">Job Profile</label>
                                    <tags-input element-id="profiletags"
                                                v-model="profileSelectedTags"
                                                :existing-tags="profile_existing_tags"
                                                :typeahead="true"
                                                :onlyExistingTags="true"
                                                :deleteOnBackspace="false"
                                                :allowDuplicates="false"></tags-input>
                                    <div id="profile-er" v-html="profileSelectedTags_error"
                                         class="form-text text-muted"></div>
                                    <!--                        <input type="text" class="form-control dash-input" id="jobProfile"-->
                                    <!--                               placeholder="Job Profile" name="job_profile">-->
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-6">
                                <div class="form-group">
                                    <label class="ep-input-label" for="job-type">Job Type</label>
                                    <!--                        <select class="form-control dash-input" id="job-type" name="semester">-->
                                    <!--                            <option value="Full Time">Full Time</option>-->
                                    <!--                            <option value="Part Time">Part Time</option>-->
                                    <!--                            <option value="Work from Home">Work From Home</option>-->
                                    <!--                        </select>-->
                                    <select class="form-control dash-input" id="job-type" name="semester"
                                            v-model="job_type_select">
                                        <option>Choose Job Type</option>
                                        <option v-for="job_type in job_types" v-bind:value="job_type.id">
                                            {{job_type.name}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-12 col-sm-12">
                                <div class="form-group">
                                    <label class="ep-input-label" for="skills">Skills</label>
                                    <tags-input element-id="skilltags"
                                                v-model="skillSelectedTags"
                                                :existing-tags="skill_existing_tags"
                                                :typeahead="true"
                                                :onlyExistingTags="false"
                                                :deleteOnBackspace="false"
                                                :allowDuplicates="false"></tags-input>
                                    <div id="skill-er" v-html="skillSelectedTags_error"
                                         class="form-text text-muted"></div>
                                    <!--                        <input type="text" class="form-control dash-input" id="skills"-->
                                    <!--                               placeholder="Skills" name="skills">-->
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-6">
                                <div class="form-group">
                                    <label class="ep-input-label" for="industry">Industry</label>
                                    <tags-input element-id="industrytags"
                                                v-model="industrySelectedTags"
                                                :existing-tags="industry_existing_tags"
                                                :typeahead="true"
                                                :onlyExistingTags="true"
                                                :deleteOnBackspace="false"
                                                :allowDuplicates="false"></tags-input>
                                    <div id="skill-er" v-html="industrySelectedTags_error"
                                         class="form-text text-muted"></div>
                                    <!--                        <input type="text" class="form-control dash-input" id="industry"-->
                                    <!--                               placeholder="Industry" name="industry">-->
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-6">
                                <div class="form-group">
                                    <label class="ep-input-lable" for="city">City</label>
                                    <tags-input element-id="citytags"
                                                v-model="citySelectedTags"
                                                :existing-tags="city_existing_tags"
                                                :typeahead="true"
                                                :onlyExistingTags="true"
                                                :deleteOnBackspace="false"
                                                :allowDuplicates="false"
                                                @keyup="onKeyUp"></tags-input>
                                    <div id="skill-er" v-html="citySelectedTags_error"
                                         class="form-text text-muted"></div>
                                    <!--                        <input type="text" class="form-control dash-input" id="city"-->
                                    <!--                               placeholder="City" name="city">-->
                                </div>
                            </div>

                        </div>
                        <div class="row padd-top-20">
                            <div class="col-md-12">
                                <div class="dashboard-heading">
                                    <h1>Internship Preferences</h1>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="ep-input-label" for="internshipProfile">Internship Profile</label>
                                    <tags-input element-id="i-profiletags"
                                                v-model="i_profileSelectedTags"
                                                :existing-tags="i_profile_existing_tags"
                                                :typeahead="true"
                                                :onlyExistingTags="true"
                                                :deleteOnBackspace="false"
                                                :allowDuplicates="false"></tags-input>
                                    <div id="profile-er" v-html="i_profileSelectedTags_error"
                                         class="form-text text-muted"></div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="ep-input-label" for="intern-type">Internship Type</label>
                                    <select class="form-control dash-input" id="intern-type" name="semester"
                                            v-model="intern_type_select">
                                        <option>Choose Job Type</option>
                                        <option v-for="job_type in job_types" v-bind:value="job_type.id">
                                            {{job_type.name}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-12 col-sm-12">
                                <div class="form-group">
                                    <label class="ep-input-label" for="skills">Skills</label>
                                    <tags-input element-id="i-skilltags"
                                                v-model="i_skillSelectedTags"
                                                :existing-tags="i_skill_existing_tags"
                                                :typeahead="true"
                                                :onlyExistingTags="false"
                                                :deleteOnBackspace="false"
                                                :allowDuplicates="false"></tags-input>
                                    <div id="profile-er" v-html="i_skillSelectedTags_error"
                                         class="form-text text-muted"></div>
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-6">
                                <div class="form-group">
                                    <label class="ep-input-label" for="industry">Industry</label>
                                    <tags-input element-id="i-industrytags"
                                                v-model="i_industrySelectedTags"
                                                :existing-tags="i_industry_existing_tags"
                                                :typeahead="true"
                                                :onlyExistingTags="true"
                                                :deleteOnBackspace="false"
                                                :allowDuplicates="false"></tags-input>
                                    <div id="profile-er" v-html="i_industrySelectedTags_error"
                                         class="form-text text-muted"></div>
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-6">
                                <div class="form-group">
                                    <label class="ep-input-label" for="city">City</label>
                                    <tags-input element-id="i_citytags"
                                                v-model="i_citySelectedTags"
                                                :existing-tags="city_existing_tags"
                                                :typeahead="true"
                                                :onlyExistingTags="true"
                                                :deleteOnBackspace="false"
                                                :allowDuplicates="false"
                                                @keyup="sCity"></tags-input>
                                    <div id="profile-er" v-html="i_citySelectedTags_error"
                                         class="form-text text-muted"></div>
                                </div>
                            </div>
                        </div>
                        <div class="row padd-top-20">
                            <div class="col-md-12">
                                <div class="dashboard-heading">
                                    <h1>Skill Up Preference</h1>
                                </div>
                            </div>
                            <div class="col-md-12 col-sm-12">
                                <div class="form-group">
                                    <label class="ep-input-label" for="skills">Skills</label>
                                    <multiselect v-model="selectedOptions" :options="options" label="skill" track-by="skill_enc_id"
                                                 :loading="isLoading" :internal-search="false" open-direction="bottom"
                                                 :searchable="true" :multiple="true" :hide-selected="true" :limit="20"
                                                 @search-change="asyncFind" :closeOnSelect="true" placeholder="Enter Atleast One Skill"
                                                 select-label="">
                                        <span slot="noOptions">Enter any keyword to search</span>
                                        <span slot="noResult">No skill found. Enter Another Keyword to search</span>
                                    </multiselect>
<!--                                    <div id="profile-er" v-html="i_skillSelectedTags_error"-->
<!--                                         class="form-text text-muted"></div>-->
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group text-center">
                                <button class="update-profile" type="submit">Update</button>
                            </div>
                        </div>
                    </form>
<!--                    <div class="row">-->
<!--                        <div class="col-md-12 margin-top-20">-->
<!--                            <div class="dash-inner-box">-->
<!--                                <div class="dashboard-heading">-->
<!--                                    <div class="row">-->
<!--                                        <div class="col-md-6">-->
<!--                                            <h1>Change Account Setting</h1>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="college-profile-form">-->
<!--                                    <form id="changePassForm" @submit.prevent="changePassword()">-->
<!--                                        <div class="row">-->
<!--                                            <div class="col-md-6">-->
<!--                                                <div class="form-group">-->
<!--                                                    <label class="ep-input-label" for="old-password">Old-->
<!--                                                        Password</label>-->
<!--                                                    <input type="password" class="form-control dash-input field-req"-->
<!--                                                           id="old-password" placeholder="Old Password"-->
<!--                                                           name="old_password">-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                            <div class="col-md-6">-->
<!--                                                <div class="form-group">-->
<!--                                                    <label class="ep-input-label" for="new-password">New-->
<!--                                                        Password</label>-->
<!--                                                    <input type="password" class="form-control dash-input field-req"-->
<!--                                                           id="new-password" placeholder="New Password"-->
<!--                                                           name="new_password">-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                            <div class="col-md-6">-->
<!--                                                <div class="form-group">-->
<!--                                                    <label class="ep-input-label" for="confirm-password">Confirm-->
<!--                                                        Password</label>-->
<!--                                                    <input type="password" class="form-control dash-input field-req"-->
<!--                                                           id="confirm-password" placeholder="Confirm New Password"-->
<!--                                                           name="repeat_new_password">-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                            <div class="col-md-12 text-center">-->
<!--                                                <div class="form-group">-->
<!--                                                    <button type="submit" class="add-course">Change Password</button>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </form>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    /*.tags-input input{*/
    /*    padding: 4px 10px;*/
    /*    height: 40px;*/
    /*    width: 100%;*/
    /*    border: 1px solid #eee;*/
    /*    margin-top: 4px;*/
    /*    border-radius: 4px;*/
    /*    -webkit-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;*/
    /*    -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;*/
    /*    -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;*/
    /*    transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;*/
    /*    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;*/
    /*    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;*/
    /*}*/
    /*.tags-input input:focus{*/
    /*    border-color: #66afe9;*/
    /*    outline: 0;*/
    /*    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102,175,233,.6);*/
    /*    box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102,175,233,.6);*/
    /*}*/
    /*.tags-input-badge.tags-input-badge-pill{*/
    /*    background-color: #ddd;*/
    /*    padding: 8px 12px;*/
    /*    border-radius: 4px;*/
    /*    margin: 0px 8px;*/
    /*}*/
    .file-upload-wrapper {
        position: relative;
        width: 330px;
        height: 50px;
    }
    .file-upload-wrapper:after {
        content: attr(data-text);
        font-size: 14px;
        position: absolute;
        top: 0;
        left: 0;
        background: #fff;
        padding: 10px 15px;
        display: block;
        width: calc(100% - 40px);
        pointer-events: none;
        z-index: 8;
        height: 48px;
        line-height: 27px;
        border: 2px solid #e8ecec;
        color: #999;
        border-radius: 10px 0px 0px 10px;
    }
    .file-upload-wrapper:before {
        content: 'Upload Resume';
        position: absolute;
        top: 0;
        right: 0;
        display: inline-block;
        height: 48px;
        background: #fff;
        color: #555;
        z-index: 9;
        font-size: 13px;
        border: 2px solid #e8ecec;
        line-height: 45px;
        padding: 0 15px;
        pointer-events: none;
        border-radius: 0 10px 10px 0;
    }
    .file-upload-wrapper:hover:before {
        background: #ff7803;
        color:#fff;
        border-color: #ff7803;
    }
    .file-upload-wrapper input {
        opacity: 0;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 9;
        height: 60px;
        margin: 0;
        padding: 0;
        display: block;
        cursor: pointer;
        width: 100%;
    }
    .file-upload-wrapper p.help-block.help-block-error{
        position: absolute;
        margin-top: 55px;
    }
</style>
<script>
    import Vue from 'vue'
    import axios from 'axios';
    import CandidateBanner from "../../components/candidateBanner";
    import CandidateSideNavLayout from '../../components/CandidateSideNavLayout.vue';
    import VoerroTagsInput from '@voerro/vue-tagsinput';
    import toastr from '../../../public/js/toastr.js';
    import Multiselect from "vue-multiselect";
    import {hideLoader, requestHeaders, showLoader} from "../../_helpers/apiHelper";

    Vue.component('tags-input', VoerroTagsInput);
    Vue.component('multiselect', Multiselect)

    export default {
        components: {
            CandidateBanner,
            CandidateSideNavLayout,
            Multiselect
        },
        data() {
            return {
                job_type_select: 'Full Time',
                intern_type_select: 'Full Time',
                job_types: [
                    {
                        "id": "Part Time",
                        "name": "Part Time"
                    },
                    {
                        "id": "Full Time",
                        "name": "Full Time"
                    },
                    {
                        "id": "Work from Home",
                        "name": "Work from Home"
                    }
                ],
                url: this.$store.getters.getDomain,
                image: '',
                uploadedPhoto: null,
                college: '',
                college_enc_id: '',
                phone: '',
                email: '',
                first_name: '',
                last_name: '',
                location: '',
                marks: '',
                //variable for job prefs
                job_prefs: '',
                intern_prefs: '',
                type: '',
                intern_type: '',
                profileSelectedTags: [],
                citySelectedTags: [],
                skillSelectedTags: [],
                industrySelectedTags: [],
                profileSelectedTags_error: '',
                citySelectedTags_error: '',
                skillSelectedTags_error: '',
                industrySelectedTags_error: '',
                i_profileSelectedTags: [],
                i_citySelectedTags: [],
                i_skillSelectedTags: [],
                i_industrySelectedTags: [],
                i_profileSelectedTags_error: '',
                i_citySelectedTags_error: '',
                i_skillSelectedTags_error: '',
                i_industrySelectedTags_error: '',
                profile_existing_tags: [],
                skill_existing_tags: [],
                city_existing_tags: [],
                industry_existing_tags: [],
                i_profile_existing_tags: [],
                i_skill_existing_tags: [],
                i_city_existing_tags: [],
                i_industry_existing_tags: [],
                typeahead: false,
                valid: false,
                onlyExistingTags: true,
                deleteOnBackspace: false,
                allowDuplicates: false,
                location_error: '',
                resumeError:'',
                selectedOptions: [],
                options: [],
                isLoading: false,
            }
        },
        mounted() {
            var t = this;
            var user = this.$store.getters.getUser;
            var url = this.$store.getters.getDomain;
            t.first_name = user['first_name'];
            t.last_name = user['last_name'];
            t.college = t.htmlDecoder(user['college']);
            t.college_enc_id = user['college_enc_id'];
            t.phone = user['phone'];
            t.email = user['email'];
            t.location = user['city'];
            t.marks = user['cgpa'];

            axios.post(`${url}api/v2/cand-profile/profile-picture`, '', {
                headers: requestHeaders()
            }).then(function (response) {
                document.getElementById("h-page-load").classList.add("hides");
                t.image = response['data'];
            }).catch(function (error) {
                // console.log(error)
            });

            axios.post(`${url}api/v2/cand-profile/get-user-prefs`, '', {
                headers: requestHeaders()
            }).then(function (response) {
                //job prefs data
                var prefProfiles = response['data']['response']['job_prefs']['userPreferredJobProfiles'];
                var prefIndustry = response['data']['response']['job_prefs']['userPreferredIndustries'];
                var prefCities = response['data']['response']['job_prefs']['userPreferredLocations'];
                var prefSkills = response['data']['response']['job_prefs']['userPreferredSkills'];
                t.job_type_select = response['data']['response']['job_prefs']['type'];
                //loop to get profiles
                for (var i = 0; i < prefProfiles.length; i++) {
                    var demo = {};
                    demo['key'] = prefProfiles[i]['jobProfileEnc']['category_enc_id'];
                    demo['value'] = prefProfiles[i]['jobProfileEnc']['name'];
                    t.profileSelectedTags.push(demo)
                }
                //loop to get cities
                for (var i = 0; i < prefCities.length; i++) {
                    var demo = {};
                    demo['key'] = prefCities[i]['cityEnc']['city_enc_id'];
                    demo['value'] = prefCities[i]['cityEnc']['name'];
                    t.citySelectedTags.push(demo)
                }
                //loop to get skills
                for (var i = 0; i < prefSkills.length; i++) {
                    var demo = {};
                    demo['key'] = prefSkills[i]['skillEnc']['skill_enc_id'];
                    demo['value'] = prefSkills[i]['skillEnc']['skill'];
                    t.skillSelectedTags.push(demo)
                }
                //loop to get industry
                for (var i = 0; i < prefIndustry.length; i++) {
                    var demo = {};
                    demo['key'] = prefIndustry[i]['industryEnc']['industry_enc_id'];
                    demo['value'] = prefIndustry[i]['industryEnc']['industry'];
                    t.industrySelectedTags.push(demo)
                }

                //internship pref data
                var i_prefProfiles = response['data']['response']['intern_prefs']['userPreferredJobProfiles'];
                var i_prefIndustry = response['data']['response']['intern_prefs']['userPreferredIndustries'];
                var i_prefCities = response['data']['response']['intern_prefs']['userPreferredLocations'];
                var i_prefSkills = response['data']['response']['intern_prefs']['userPreferredSkills'];
                //loop to get profiles
                for (var i = 0; i < i_prefProfiles.length; i++) {
                    var demo = {};
                    demo['key'] = i_prefProfiles[i]['jobProfileEnc']['category_enc_id'];
                    demo['value'] = i_prefProfiles[i]['jobProfileEnc']['name'];
                    t.i_profileSelectedTags.push(demo)
                }
                //loop to get cities
                for (var i = 0; i < i_prefCities.length; i++) {
                    var demo = {};
                    demo['key'] = i_prefCities[i]['cityEnc']['city_enc_id'];
                    demo['value'] = i_prefCities[i]['cityEnc']['name'];
                    t.i_citySelectedTags.push(demo)
                }
                //loop to get skills
                for (var i = 0; i < i_prefSkills.length; i++) {
                    var demo = {};
                    demo['key'] = i_prefSkills[i]['skillEnc']['skill_enc_id'];
                    demo['value'] = i_prefSkills[i]['skillEnc']['skill'];
                    t.i_skillSelectedTags.push(demo)
                }
                //loop to get industry
                for (var i = 0; i < i_prefIndustry.length; i++) {
                    var demo = {};
                    demo['key'] = i_prefIndustry[i]['industryEnc']['industry_enc_id'];
                    demo['value'] = i_prefIndustry[i]['industryEnc']['industry'];
                    t.i_industrySelectedTags.push(demo)
                }

                t.intern_type_select = response['data']['response']['intern_prefs']['type'];

                t.job_prefs = response['data']['response']['job_prefs'];
                t.intern_prefs = response['data']['response']['intern_prefs'];

            }).catch(function (error) {
                // console.log(error)
            })

            //request to get job profiles
            axios.post(`${url}api/v2/cand-profile/profiles?type=Jobs`, '', {}).then(function (response) {
                t.profile_existing_tags = response['data']['response'];
            });

            //request to get internship profiles
            axios.post(`${url}api/v2/cand-profile/profiles?type=Internships`, '', {}).then(function (response) {
                t.i_profile_existing_tags = response['data']['response'];
            });

            //request to get skills
            axios.post(`${url}api/v2/cand-profile/get-skills`, '', {}).then(function (response) {
                t.skill_existing_tags = response['data']['response'];
                t.i_skill_existing_tags = response['data']['response'];
            });

            //request to get industry
            axios.post(`${url}api/v2/cand-profile/get-industry`, '', {}).then(function (response) {
                t.industry_existing_tags = response['data']['response'];
                t.i_industry_existing_tags = response['data']['response'];
            });
            t.getUserPref();
        },
        computed: {
            changeImage() {
                return this.$store.getters.getImage;
            },
        },
        watch: {
            changeImage(value) {
                var t = this;
                t.image = value;
            },
        },
        methods: {
            // onPhotoUploaded(event) {
            //     var t = this;
            //     var url = this.$store.getters.getDomain;
            //     this.uploadedPhoto = event.target.files[0];
            //     const fd = new FormData();
            //     fd.append('profile_image', this.uploadedPhoto, this.uploadedPhoto.name);
            //     const headers = {
            //         'Authorization': "Bearer " + localStorage.getItem('token'),
            //         'source': localStorage.getItem('source'),
            //         'Content-Type': 'application/json'
            //     };
            //     this.loaderShow();
            //     axios.post(`${url}api/v2/cand-profile/upload-profile-picture`, fd, {
            //         headers: headers,
            //         // onUploadProgress: uploadEvent => {
            //         //     console.log('Upload Progress: ' + Math.round(uploadEvent.loaded/uploadEvent.total * 100) + "%")
            //         // }
            //     })
            //         .then(res => {
            //             this.loaderHide();
            //             if (res.status == 200) {
            //                 var image = res['data']['response']['image'];
            //                 t.$store.dispatch("setImage", image);
            //                 toastr.success('Picture Uploaded Successfully', 'Success');
            //             } else {
            //                 toastr.error('Some error occurred. Try again later', 'Oops!!');
            //             }
            //         })
            //
            // },
            onKeyUp() {
                var a = document.querySelector('#citytags').previousElementSibling.value;
                var t = this;
                axios.post(`${this.url}api/v2/cand-profile/get-cities?q=${a}`, '', {}).then(function (response) {
                    t.city_existing_tags = response['data']['response'];
                })
            },
            sCity() {
                var a = document.querySelector('#i_citytags').previousElementSibling.value;
                var t = this;
                axios.post(`${this.url}api/v2/cand-profile/get-cities?q=${a}`, '', {}).then(function (response) {
                    t.city_existing_tags = response['data']['response'];
                })
            },
            update() {
                var t = this;
                var url = this.$store.getters.getDomain;
                t.location_error = '';
                t.profileSelectedTags_error = '';
                t.citySelectedTags_error = '';
                t.industrySelectedTags_error = '';
                t.skillSelectedTags_error = '';
                t.i_profileSelectedTags_error = '';
                t.i_citySelectedTags_error = '';
                t.i_industrySelectedTags_error = '';
                t.i_skillSelectedTags_error = '';

                // if(t.selectedOptions.length){
                    axios.post(`${url}api/v2/skill-up/save-pref-skills`, {skills: t.selectedOptions}, {headers: requestHeaders()}).then(function (response) {
                        if (response['data']['response']['status'] == 200) {
                            toastr.success('Skills Added Successfully', 'Success');
                        } else {
                            toastr.error('Some error occurred. Try again later', 'Oops!!');
                        }
                    });
                // }

                if (t.location == "" || t.location == null) {
                    t.location_error = "location can't be empty";
                    return false;
                }

                var data = {
                    'location': t.location,
                    'cgpa': t.marks,
                };

                if (t.profileSelectedTags.length != 0 || t.citySelectedTags.length != 0 || t.industrySelectedTags.length != 0 || t.skillSelectedTags.length != 0) {
                    var flag = 0;

                    if (t.profileSelectedTags.length == 0) {
                        t.profileSelectedTags_error = "this field can't be empty";
                        flag = 1;
                    }
                    if (t.citySelectedTags.length == 0) {
                        t.citySelectedTags_error = "this field can't be empty";
                        flag = 1;
                    }
                    if (t.industrySelectedTags.length == 0) {
                        t.industrySelectedTags_error = "this field can't be empty";
                        flag = 1;
                    }
                    if (t.skillSelectedTags.length == 0) {
                        t.skillSelectedTags_error = "this field can't be empty";
                        flag = 1;
                    }

                    if (flag == 1) {
                        return false;
                    } else {
                        var user_prefs = {
                            'for': 'Jobs',
                            'profiles': t.profileSelectedTags,
                            'type': t.job_type_select,
                            'locations': t.citySelectedTags,
                            'industry': t.industrySelectedTags,
                            'skills': t.skillSelectedTags,
                        };
                        axios.post(`${url}api/v2/cand-profile/save-applications`, {data: user_prefs}, {
                            headers: requestHeaders()
                        }).then(function (response) {

                        }).catch(function (error) {
                            // console.log(error)
                        });
                    }

                } else {
                    console.log('not filled');
                }

                if (t.i_profileSelectedTags.length != 0 || t.i_citySelectedTags.length != 0 || t.i_industrySelectedTags.length != 0 || t.i_skillSelectedTags.length != 0) {
                    var flag = 0;

                    if (t.i_profileSelectedTags.length == 0) {
                        t.i_profileSelectedTags_error = "this field can't be empty";
                        flag = 1;
                    }
                    if (t.i_citySelectedTags.length == 0) {
                        t.i_citySelectedTags_error = "this field can't be empty";
                        flag = 1;
                    }
                    if (t.i_industrySelectedTags.length == 0) {
                        t.i_industrySelectedTags_error = "this field can't be empty";
                        flag = 1;
                    }
                    if (t.i_skillSelectedTags.length == 0) {
                        t.i_skillSelectedTags_error = "this field can't be empty";
                        flag = 1;
                    }

                    if (flag == 1) {
                        return false;
                    } else {
                        var intern_user_prefs = {
                            'for': 'Internships',
                            'profiles': t.i_profileSelectedTags,
                            'type': t.intern_type_select,
                            'locations': t.i_citySelectedTags,
                            'industry': t.i_industrySelectedTags,
                            'skills': t.i_skillSelectedTags
                        };
                        showLoader();
                        axios.post(`${url}api/v2/cand-profile/save-applications`, {data: intern_user_prefs}, {
                            headers: requestHeaders()
                        }).then(function (response) {
                            hideLoader();
                        }).catch(function (error) {
                            // console.log(error)
                        });
                    }
                }

                if (t.location) {
                    showLoader();
                    axios.post(`${url}api/v2/cand-profile/save-basic-info`, data, {
                        headers: requestHeaders()
                    }).then(function (response) {
                        hideLoader();
                        t.$store.dispatch('setUser', response['data']['response']['data']);
                    }).catch(function (error) {
                        console.log(error)
                    });
                }
            },
            uploadResume(event){
                var t = this;
                var elem = event.currentTarget;
                if(document.getElementById("resume_upload").files[0]) {
                    var file_val = document.getElementById("resume_upload").files[0].name;
                    $(".file-upload-wrapper").attr("data-text", file_val);
                    var filePath = document.getElementById("resume_upload").value;

                    // Allowing file type
                    var allowedExtensions = /(\.doc|\.docs|\.pdf)$/i;

                    if (!allowedExtensions.exec(filePath)) {
                        t.resumeError = "Resume file type must be .doc, .docx and .pdf";
                        return false;
                    }
                    var FileSize = document.getElementById("resume_upload").files[0].size / 1024 / 1024;
                    if (FileSize > 2) {
                        t.resumeError = "Resume file size must be less than 2MB";
                        return false;
                    }
                    t.resumeError = "";
                    t.updateResume();
                } else{
                    t.resumeError = "";
                    $('.file-upload-wrapper').attr('data-text', 'No file chosed');
                }
            },
            updateResume(){
                var t = this;
                var url = this.$store.getters.getDomain;
                let tempResume = document.getElementById("resume_upload").files[0];
                const ru = new FormData();
                ru.append('resume', tempResume);
                showLoader();
                axios.post(`${url}api/v2/cand-profile/upload-resume`, ru, {
                    headers: requestHeaders(),
                })
                    .then(res => {
                        hideLoader();
                        if (res.status == 200) {
                            toastr.success('Resume Uploaded Successfully', 'Success');
                        } else {
                            toastr.error('Some error occurred. Try again later', 'Oops!!');
                        }
                    })
            },
            changePassword() {
                var t = this;
                var url = t.$store.getters.getDomain;
                if(!t.validateForm()){
                    return false;
                }
                var elements = document.getElementById('changePassForm').elements;
                var obj = {};
                for (var i = 0; i < elements.length; i++) {
                    var item = elements.item(i);
                    if (item.name != "") {
                        obj[item.name] = item.value;
                    }
                }
                showLoader();
                //request to update basic info
                axios.post(`${url}api/v2/auth/change-password`, obj, {headers: requestHeaders()}).then(function (response) {
                    hideLoader();
                    if (response['data']['response']['status'] == 200) {
                        toastr.success('Password changed successfully', 'Success');
                        for (var i = 0; i < elements.length; i++) {
                            var item = elements.item(i);
                            item.value = "";
                        }
                    } else if (response['data']['response']['status'] == 403) {
                        toastr.error('The old password did not match. Please Try again', 'Oops!!');
                    } else if (response['data']['response']['status'] == 409) {
                        toastr.error(response['data']['response'][0].new_password[0], 'Oops!!');
                    } else {
                        toastr.error('Some error occurred. Try again later', 'Oops!!');
                    }
                });
            },
            asyncFind(query) {
                this.isLoading = true
                var t = this;
                var url = this.$store.getters.getDomain;
                axios.post(`${url}api/v2/skill-up/get-skills`, {keyword: query}, {headers: requestHeaders()}).then(function (response) {
                    t.options = response['data']['response']['skills'];
                    t.isLoading = false;
                });
            },
            validateForm: function () {
                var x, y, z, i, valid = true, a = this;
                x = document.getElementById("changePassForm");
                y = x.getElementsByTagName("input");
                for (i = 0; i < y.length; i++) {
                    if (y[i].value == "") {
                        y[i].className += " invalid";
                        valid = false;
                    } else {
                        y[i].classList.remove('invalid');
                    }
                }
                if (document.getElementById('new-password').value != document.getElementById('confirm-password').value) {
                    document.getElementById('new-password').className += " invalid";
                    document.getElementById('confirm-password').className += " invalid";
                    valid = false;
                }

                if (document.getElementById('new-password').value.length < 8) {
                    alert('Password must have 8 characters. Use small letters with combination of Capitals and numbers with special symbols like @*.')
                    document.getElementById('new-password').className += " invalid";
                    valid = false;
                }
                return valid;
            },
            getUserPref(){
                var t = this;
                var url = this.$store.getters.getDomain;
                axios.post(`${url}api/v2/skill-up/user-pref-skills`, "", {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        t.selectedOptions = response['data']['response']['skills'];
                    }
                });
            },
            htmlDecoder(str) {
                var textArea = document.createElement('textarea');
                textArea.innerHTML = str;
                return textArea.value;
            }
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>